
import { useState, useEffect } from 'react';
import Icon from '../ui/AppIcon';

interface MobileConversionBarProps {
  isVisible?: boolean;
}

const MobileConversionBar = ({ isVisible = true }: MobileConversionBarProps) => {
  const [scrollDepth, setScrollDepth] = useState(0);
  const [showPhoneOption, setShowPhoneOption] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;

      setScrollDepth(scrollPercentage);
      setShowPhoneOption(scrollPercentage > 30);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <>
      {/* Desktop Version - Integrated into main navigation */}
      <div className="hidden lg:block">
        {/* Desktop conversion elements are handled by StickyAnchorNav */}
      </div>

      {/* Mobile Sticky Bottom Bar */}
      <div className="fixed bottom-0 left-0 right-0 z-conversion-bar lg:hidden bg-background border-t border-border shadow-lg">
        <div className="flex items-center justify-between p-4">
          {showPhoneOption ? (
            <>
              {/* Phone Consultation Option */}
              <a
                href="tel:+919405709042"
                className="flex-1 flex items-center justify-center space-x-2 bg-secondary text-secondary-foreground px-4 py-3 rounded-lg font-semibold transition-default hover:bg-secondary/90 mr-2"
                style={{ minHeight: '48px' }}
              >
                <Icon name="PhoneIcon" size={20} variant="solid" />
                <span>Call Now</span>
              </a>

              {/* WhatsApp Option */}
              <a
                href="https://wa.me/919730088168"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex items-center justify-center space-x-2 bg-success text-success-foreground px-4 py-3 rounded-lg font-semibold transition-default hover:bg-success/90 ml-2"
                style={{ minHeight: '48px' }}
              >
                <Icon name="ChatBubbleLeftRightIcon" size={20} variant="solid" />
                <span>WhatsApp</span>
              </a>
            </>
          ) : (
            <>
              {/* Primary CTA */}
              <a
                href="#apply-now"
                className="flex-1 flex items-center justify-center space-x-2 bg-accent text-accent-foreground px-6 py-3 rounded-lg font-semibold shadow-cta transition-default hover:bg-accent/90"
                style={{ minHeight: '48px' }}
              >
                <Icon name="AcademicCapIcon" size={20} variant="solid" />
                <span>Apply Now - Free Counseling</span>
              </a>
            </>
          )}
        </div>

        {/* Urgency Message */}
        {scrollDepth > 50 && (
          <div className="bg-warning/10 border-t border-warning/20 px-4 py-2">
            <div className="flex items-center justify-center space-x-2 text-sm">
              <Icon name="ClockIcon" size={16} className="text-warning" variant="solid" />
              <span className="text-text-primary font-medium">
                Limited counseling slots available
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Spacer for mobile content to prevent overlap */}
      <div className="h-20 lg:hidden" />
    </>
  );
};

export default MobileConversionBar;